<div role="progressbar" class="progress-bar" [ngStyle]="{ background: backgroundColor }">
  <div class="progress" [ngStyle]="{ width: percentage + '%', background: progressColor }"></div>
</div>
